import qs from 'qs'
import { removeEmpty } from 'utils'
import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const getAuditLog = ({ start_date, end_date, log_activity_type, action_user, toppic_code ,report_header_id,page,size}) => {
  const params = removeEmpty({
    start_date, 
    end_date, 
    log_activity_type, 
    action_user, 
    toppic_code ,
    report_header_id,
    page,
    size
  })


  const config = {
    method: 'get',
    url: `/api/v1/audit_log`,
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res?.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const exportAuditLog = ({ start_date, end_date, log_activity_type, action_user, toppic_code ,report_header_id}) => {
  const params = removeEmpty({
    start_date, 
    end_date, 
    log_activity_type, 
    action_user, 
    toppic_code ,
    report_header_id
  })

  const config = {
    method: 'get',
    url: '/api/v1/audit_log/export',
    params,
    responseType: 'blob',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res?.data) {
        saveFileFromResponse(res)
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const saveFileFromResponse = (response) => {
  // const filenameRegex = /filename[^;=\n]*\*?=(?:utf-8'')?((['"]).*?\2|[^;\n\\/:*?"<>|]*)$/
  const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
  // const contentDispostion = response.request.getResponseHeader('Content-Disposition')

  const filename = 'Event_Tracking.xlsx'

  const link = document.createElement('a')

  link.href = downloadUrl

  link.setAttribute('download', filename) //any other extension

  document.body.appendChild(link)

  link.click()

  link.remove()
}